import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import activityDomainsFr from './activityDomains.fr.json';
import activityZonesFr from './activityZones.fr.json';
import donationTypesFr from './donationTypes.fr.json';
import fr from './fr.json';
import statusesFr from './statuses.fr.json';
import nationalitiesFr from './nationalities.fr.json';
import targetPersonsFr from './targetPersons.fr.json';
import sustainableDevelopmentGoalsFr from './sustainableDevelopmentGoals.fr.json';
import tagsFr from './tags.fr.json';
import targetPopulationsFr from './targetPopulations.fr.json';
import numberOfBeneficiariesFr from './numberOfBeneficiaries.fr.json';

// Force French language only
i18n.use(initReactI18next).init({
  resources: {
    fr: {
      translation: fr,
      activityDomains: activityDomainsFr,
      activityZones: activityZonesFr,
      donationTypes: donationTypesFr,
      statuses: statusesFr,
      nationalities: nationalitiesFr,
      targetPersons: targetPersonsFr,
      sustainableDevelopmentGoals: sustainableDevelopmentGoalsFr,
      tags: tagsFr,
      targetPopulations: targetPopulationsFr,
      numberOfBeneficiaries: numberOfBeneficiariesFr,
    },
  },
  debug: process.env.NODE_ENV === 'development',
  lng: 'fr',
  fallbackLng: 'fr',
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
